import { web3Actions } from './web3.action';
import { userActions } from './user.action';
import { adminActions } from './admin.action';
import { amenitiesActions } from './amenities.action';
import { complianceActions } from './compliance.action';
import { categoryActions } from './category.action';

type ActionType = typeof web3Actions &
  typeof userActions &
  typeof adminActions &
  typeof amenitiesActions &
  typeof complianceActions &
  typeof categoryActions;

export const actions: ActionType = {
  ...web3Actions,
  ...userActions,
  ...adminActions,
  ...amenitiesActions,
  ...complianceActions,
  ...categoryActions,
};
